import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { APP } from "@/constants/testIds";
import LoginForm from "@/components/LoginForm";
import RegisterForm from "@/components/RegisterForm";

function AuthSidePanel() {
  return (
    <div className="hidden lg:block relative bg-[color:var(--fg)] text-[color:var(--bg)] p-12 overflow-hidden">
      <div className="stripes absolute inset-0 opacity-5" />
      <div className="relative h-full flex flex-col justify-between">
        <div className="font-mono-tight text-xs uppercase tracking-widest opacity-60">// login.terminal</div>
        <div>
          <h2 className="font-display text-6xl leading-[0.9]">
            Ideas that<br />
            <span className="text-[color:var(--yellow)]">actually</span><br />ship.
          </h2>
          <p className="mt-8 text-sm opacity-70 max-w-sm leading-relaxed">
            No purple gradients. No AI slop. Just real trending business
            opportunities from the categories with the biggest tailwinds in 2026.
          </p>
        </div>
        <div className="text-xs uppercase tracking-widest opacity-60">powered by gemini 3 flash</div>
      </div>
    </div>
  );
}

export default function Auth() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const hasReferral = !!params.get("ref");
  const initialMode = hasReferral || params.get("mode") !== "login" ? "signup" : "login";
  const [mode, setMode] = useState(initialMode);

  const onSuccess = () => nav("/app");
  const isLogin = mode === "login";

  let heading;
  let subheading;
  let toggleLabel;
  if (isLogin) {
    heading = "Log in.";
    subheading = "Welcome back to your saved ideas.";
    toggleLabel = "No account? Sign up →";
  } else {
    heading = "Create account.";
    subheading = "Free forever. No credit card.";
    toggleLabel = "Already have an account? Log in →";
  }

  return (
    <div className="min-h-screen grain flex flex-col">
      <nav className="border-b border-[color:var(--line)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5">
          <Link to="/" data-testid={APP.navLogo} className="flex items-center gap-2 w-fit">
            <div className="w-7 h-7 bg-[color:var(--fg)] text-[color:var(--bg)] flex items-center justify-center font-display text-sm">T</div>
            <span className="font-display text-lg">TRENDING/IDEAS</span>
          </Link>
        </div>
      </nav>

      <div className="flex-1 grid lg:grid-cols-2">
        <AuthSidePanel />

        <div className="flex items-center justify-center p-6 lg:p-16">
          <div className="w-full max-w-md">
            <div className="tag mb-4">{isLogin ? "// re-entry" : "// new operator"}</div>
            <h1 className="font-display text-4xl lg:text-5xl leading-none">{heading}</h1>
            <p className="mt-3 text-sm text-[color:var(--muted)]">{subheading}</p>

            {isLogin ? <LoginForm onSuccess={onSuccess} /> : <RegisterForm onSuccess={onSuccess} />}

            <button
              data-testid={APP.authToggleMode}
              onClick={() => setMode(isLogin ? "signup" : "login")}
              className="mt-6 text-sm text-[color:var(--muted)] hover:text-[color:var(--fg)] underline underline-offset-4"
            >
              {toggleLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
